import React from 'react';
import 'font-awesome/css/font-awesome.min.css';
import { MyRouter } from './Router';
function App() {
  return (
    <MyRouter />
  );
}

export default App;
